import type { SVGProps } from "react";
export function Upload(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m2.60866 11.3333c0 .8284.70078 1.5 1.56522 1.5h6.95652c.8644 0 1.5652-.6716 1.5652-1.5v-.6667c0-.2761.2336-.5.5218-.5.2881 0 .5217.2239.5217.5v.6667c0 1.3807-1.1679 2.5-2.6087 2.5h-6.95652c-1.44074 0-2.60869-1.1193-2.60869-2.5v-.6667c0-.2761.23359-.5.52173-.5.28815 0 .52174.2239.52174.5zm1.89195-5.64645c-.20375-.19526-.20375-.51185 0-.70711l2.78263-2.66667c.09781-.09376.23054-.14644.3689-.14644.13837 0 .2711.05268.36891.14644l2.78265 2.66667c.2037.19526.2037.51185 0 .70711-.2038.19526-.5341.19526-.7379 0l-1.89192-1.81312v6.79287c0 .2762-.2336.5-.52174.5s-.52174-.2238-.52174-.5v-6.79287l-1.89194 1.81312c-.20375.19526-.5341.19526-.73785 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
